import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorThreads,
  fetchProcessorThreadsAttributes,
  fetchProcessorThreadsById,
  updateProcessorThreads,
  updateStatusInProcessorThreads,
} from "./thunk";

interface CategoryState {
  processor_threads_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_threads_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_threads",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorThreadsAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorThreadsAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_threads_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorThreadsAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Threads";
      })
      .addCase(fetchProcessorThreadsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorThreadsById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorThreadsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorThreads.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_threads_list = state.processor_threads_list.map((processor_threads) =>
          processor_threads.id === action.payload.id ? action.payload : processor_threads
        );
      })
      .addCase(addProcessorThreads.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorThreads.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_threads_list = state.processor_threads_list.map((processor_threads) =>
          processor_threads.id === action.payload.id ? action.payload : processor_threads
        );
      })
      .addCase(updateProcessorThreads.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorThreads.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorThreads.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
